import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // Added useNavigate if not present, but Link is used. keeping Link.
import axios from "axios";
import { imageBaseURL } from "../../actions/Base_URL";

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [loginDropdownOpen, setLoginDropdownOpen] = useState(false);
    const [programsDropdownOpen, setProgramsDropdownOpen] = useState(false);
    const [logoUrl, setLogoUrl] = useState("https://nvcti.iitism.ac.in/assets/images/logo/logo-dark.png"); // Fallback
    const [innovationDropdownOpen, setInnovationDropdownOpen] = useState(false);
    const [studentSchemesOpen, setStudentSchemesOpen] = useState(false);
    const innovationDropdownRef = useRef(null);
    const [logoRightUrl, setLogoRightUrl] = useState(""); // Right Logo State
    const menuRef = useRef(null);
    const toggleRef = useRef(null);
    const loginDropdownRef = useRef(null);
    const programsDropdownRef = useRef(null);

    useEffect(() => {
        const fetchLogo = async () => {
            try {
                const response = await axios.get("https://api.nvcti.in/api/images/images?type=logo");
                // Expected response structure handling
                let images = [];
                if (response.data && Array.isArray(response.data.images)) {
                    images = response.data.images;
                } else if (Array.isArray(response.data)) {
                    images = response.data;
                } else if (response.data && Array.isArray(response.data.data)) {
                    images = response.data.data;
                }

                if (images.length > 0) {
                    // Assuming path is the field as seen in PortalImages
                    const firstLogo = images[0];
                    if (firstLogo.path) {
                        setLogoUrl(`${imageBaseURL}${firstLogo.path}`);
                    }
                }
            } catch (error) {
                console.error("Failed to fetch logo:", error);
            }
        };

        const fetchLogoRight = async () => {
            try {
                const response = await axios.get("https://api.nvcti.in/api/images/images?type=logo-right");
                let images = [];
                if (response.data && Array.isArray(response.data.images)) {
                    images = response.data.images;
                } else if (Array.isArray(response.data)) {
                    images = response.data;
                } else if (response.data && Array.isArray(response.data.data)) {
                    images = response.data.data;
                }

                if (images.length > 0) {
                    const firstLogo = images[0];
                    if (firstLogo.path) {
                        setLogoRightUrl(`${imageBaseURL}${firstLogo.path}`);
                    }
                }
            } catch (error) {
                console.error("Failed to fetch right logo:", error);
            }
        };

        fetchLogo();
        fetchLogoRight();
    }, []);

    useEffect(() => {
        function handleDocumentClick(event) {
            const clickedInsideMenu = menuRef.current && menuRef.current.contains(event.target);
            const clickedToggle = toggleRef.current && toggleRef.current.contains(event.target);
            if (!clickedInsideMenu && !clickedToggle) {
                setIsOpen(false);
            }
            // Dropdowns
            // Only close login dropdown if click is outside both the desktop dropdown AND the mobile menu
            if (loginDropdownRef.current &&
                !loginDropdownRef.current.contains(event.target) &&
                (!menuRef.current || !menuRef.current.contains(event.target))) {
                setLoginDropdownOpen(false);
            }
            if (programsDropdownRef.current && !programsDropdownRef.current.contains(event.target)) {
                setProgramsDropdownOpen(false);
            }
            if (innovationDropdownRef.current && !innovationDropdownRef.current.contains(event.target)) {
                setInnovationDropdownOpen(false);
            }
        }
        document.addEventListener("click", handleDocumentClick);
        return () => document.removeEventListener("click", handleDocumentClick);
    }, []);

    useEffect(() => {
        function onKeyDown(e) {
            if (e.key === "Escape") {
                setIsOpen(false);
                setLoginDropdownOpen(false);
                setProgramsDropdownOpen(false);
                setInnovationDropdownOpen(false);
            }
        }
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, []);



    return (
        <>
            <header className="bg-white shadow-md border-b border-gray-200 sticky top-0 z-50">
                <div className="max-w-screen-xl mx-auto px-4 flex items-center justify-between h-20">
                    <div>
                        <Link to="/home" onClick={() => window.scrollTo(0, 0)}>
                            <img
                                src={logoUrl}
                                alt="NVCTI Logo"
                                className="h-16 ml-6 mt-6 mb-6 brightness-100 object-contain cursor-pointer"
                            />
                        </Link>
                    </div>

                    <nav className="hidden md:flex space-x-6 items-center font-semibold text-[15px] gap-2 ml-auto mr-2">
                        <Link
                            to="/about"
                            onClick={() => window.scrollTo(0, 0)}
                            className="text-gray-800 hover:text-blue-600 transition-colors"
                        >
                            About Us
                        </Link>

                        <div className="relative" ref={innovationDropdownRef}>
                            <button
                                onClick={() => setInnovationDropdownOpen(!innovationDropdownOpen)}
                                className="flex items-center gap-1 text-gray-800 hover:text-blue-600 transition-colors focus:outline-none font-bold"
                            >
                                Innovation
                                <svg
                                    className={`w-4 h-4 transition-transform duration-200 ${innovationDropdownOpen ? 'rotate-180' : ''}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {innovationDropdownOpen && (
                                <div className="absolute top-full left-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-xl animate-in fade-in slide-in-from-top-2 duration-200 z-50">
                                    <div className="py-1">
                                        <Link
                                            to="/programs/awards"
                                            onClick={() => { setInnovationDropdownOpen(false); window.scrollTo(0, 0); }}
                                            className="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors border-b border-gray-100"
                                        >
                                            Innovation Awards
                                        </Link>
                                        <div
                                            className="relative"
                                            onMouseEnter={() => setStudentSchemesOpen(true)}
                                            onMouseLeave={() => setStudentSchemesOpen(false)}
                                        >
                                            <div className="flex items-center justify-between px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors cursor-pointer w-full">
                                                <span className="font-medium whitespace-nowrap">Student Innovation Schemes</span>
                                                <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                                            </div>
                                            {/* Nested Submenu with invisible bridge padding */}
                                            {studentSchemesOpen && (
                                                <div className="absolute left-full top-0 -ml-2 pl-2 w-48 z-[60]">
                                                    <div className="bg-white border border-gray-200 rounded-lg shadow-xl py-1">
                                                        <Link
                                                            to="/programs/mpdi"
                                                            onClick={() => { setInnovationDropdownOpen(false); setStudentSchemesOpen(false); window.scrollTo(0, 0); }}
                                                            className="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors border-b border-gray-100"
                                                        >
                                                            MPDI
                                                        </Link>
                                                        <Link
                                                            to="/programs/ipd"
                                                            onClick={() => { setInnovationDropdownOpen(false); setStudentSchemesOpen(false); window.scrollTo(0, 0); }}
                                                            className="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors"
                                                        >
                                                            IPD
                                                        </Link>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {/* <div className="relative group">
                                            <Link
                                                to="#"
                                                className="block px-4 py-2 text-gray-400 cursor-not-allowed border-t border-gray-100 flex items-center justify-between"
                                                onClick={(e) => e.preventDefault()}
                                            >
                                                Our Innovation
                                                <span className="text-[10px] bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full font-bold ml-2">Soon</span>
                                            </Link>
                                        </div> */}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Programs Dropdown */}
                        <div className="relative" ref={programsDropdownRef}>
                            <button
                                onClick={() => setProgramsDropdownOpen(!programsDropdownOpen)}
                                className="flex items-center gap-1 text-gray-800 hover:text-blue-600 transition-colors focus:outline-none font-bold"
                            >
                                Programs
                                <svg
                                    className={`w-4 h-4 transition-transform duration-200 ${programsDropdownOpen ? 'rotate-180' : ''}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {programsDropdownOpen && (
                                <div className="absolute top-full left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200 z-50">
                                    <div className="py-1">
                                        <Link
                                            to="/programs/mpdi"
                                            onClick={() => { setProgramsDropdownOpen(false); window.scrollTo(0, 0); }}
                                            className="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors border-b border-gray-100"
                                        >
                                            MPDI
                                        </Link>
                                        <Link
                                            to="/programs/ipd"
                                            onClick={() => { setProgramsDropdownOpen(false); window.scrollTo(0, 0); }}
                                            className="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors border-b border-gray-100"
                                        >
                                            IPD
                                        </Link>
                                        <Link
                                            to="/programs/clubs"
                                            onClick={() => { setProgramsDropdownOpen(false); window.scrollTo(0, 0); }}
                                            className="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors border-b border-gray-100"
                                        >
                                            Student Clubs
                                        </Link>
                                        {/* <Link
                                            to="/programs/awards"
                                            onClick={() => setProgramsDropdownOpen(false)}
                                            className="block px-4 py-2 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-colors"
                                        >
                                            Innovation Awards
                                        </Link> */}
                                    </div>
                                </div>
                            )}
                        </div>

                        <Link to="/blog" onClick={() => window.scrollTo(0, 0)} className="text-gray-800 hover:text-blue-600 transition-colors">
                            Blog
                        </Link>
                        <Link to="/gallery" onClick={() => window.scrollTo(0, 0)} className="text-gray-800 hover:text-blue-600 transition-colors">
                            Gallery
                        </Link>
                        <Link to="/get-involved" onClick={() => window.scrollTo(0, 0)} className="text-gray-800 hover:text-blue-600 transition-colors">
                            Get Involved
                        </Link>
                        <Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="text-gray-800 hover:text-blue-600 transition-colors">
                            Contact
                        </Link>
                        <div className="relative" ref={loginDropdownRef}>
                            <button
                                onClick={() => setLoginDropdownOpen(!loginDropdownOpen)}
                                className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-6 rounded-md transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg"
                            >
                                Login
                                <svg
                                    className={`w-4 h-4 transition-transform duration-200 ${loginDropdownOpen ? 'rotate-180' : ''}`}
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                                </svg>
                            </button>
                            {loginDropdownOpen && (
                                <div className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                                    <div className="py-1">
                                        <Link
                                            to="/auth/login"
                                            state={{ role: 'labincharge' }}
                                            onClick={() => setLoginDropdownOpen(false)}
                                            className="flex items-center justify-between px-5 py-3 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-all duration-150 border-b border-gray-100 group"
                                        >
                                            <span className="font-medium">Lab Incharge</span>
                                            <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </Link>
                                        <Link
                                            to="/auth/login"
                                            state={{ role: 'admin' }}
                                            onClick={() => setLoginDropdownOpen(false)}
                                            className="flex items-center justify-between px-5 py-3 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-all duration-150 border-b border-gray-100 group"
                                        >
                                            <span className="font-medium">Admin</span>
                                            <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </Link>
                                        <Link
                                            to="/auth/login"
                                            state={{ role: 'student' }}
                                            onClick={() => setLoginDropdownOpen(false)}
                                            className="flex items-center justify-between px-5 py-3 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-all duration-150 group"
                                        >
                                            <span className="font-medium">Student</span>
                                            <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </nav>

                    {/* Right Side Logo */}
                    {logoRightUrl && (
                        <div className="hidden md:block">
                            <img
                                src={logoRightUrl}
                                alt="Right Logo"
                                className="h-16 ml-4 mt-6 mb-6 brightness-100 object-contain"
                            />
                        </div>
                    )}

                    <button
                        ref={toggleRef}
                        type="button"
                        aria-label="Toggle navigation menu"
                        aria-expanded={isOpen}
                        onClick={() => setIsOpen((prev) => !prev)}
                        className="inline-flex items-center justify-center p-2 rounded md:ml-4 text-gray-800 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 md:hidden"
                    >
                        <span className="sr-only">Open main menu</span>
                        <svg
                            className={`h-7 w-7 transition-transform ${isOpen ? "rotate-90" : "rotate-0"}`}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                        >
                            {isOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5" />
                            )}
                        </svg>
                    </button>
                </div>
            </header>
            <div
                ref={menuRef}
                className={`bg-white border-b border-gray-200 shadow-lg md:hidden overflow-hidden transition-all duration-300 fixed top-20 left-0 right-0 z-50 ${isOpen ? "max-h-screen" : "max-h-0"
                    }`}
            >
                <div className="max-w-screen-xl mx-auto px-6 py-3 space-y-2 font-semibold text-[15px] overflow-y-auto">
                    <Link to="/about" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block text-gray-800 hover:text-blue-600 py-2">
                        About Us
                    </Link>

                    <div className="py-2">
                        <span className="block text-gray-500 text-sm uppercase tracking-wider mb-1">Programs</span>
                        <Link to="/programs/mpdi" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block pl-4 text-gray-800 hover:text-blue-600 py-1">
                            - MPDI
                        </Link>
                        <Link to="/programs/ipd" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block pl-4 text-gray-800 hover:text-blue-600 py-1">
                            - IPD
                        </Link>
                        <Link to="/programs/clubs" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block pl-4 text-gray-800 hover:text-blue-600 py-1">
                            - Student Clubs
                        </Link>
                        <Link to="/programs/awards" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block pl-4 text-gray-800 hover:text-blue-600 py-1">
                            - Innovation Awards
                        </Link>
                    </div>

                    <div className="py-2">
                        <span className="block text-gray-500 text-sm uppercase tracking-wider mb-1">Innovation</span>
                        <Link to="/programs/awards" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block pl-4 text-gray-800 hover:text-blue-600 py-1">
                            - Innovation Awards
                        </Link>
                        <div className="block pl-4 text-gray-800 py-1 font-semibold">
                            - Student Innovation Schemes
                        </div>
                        <Link to="/programs/mpdi" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block pl-8 text-gray-600 hover:text-blue-600 py-1">
                            -- MPDI
                        </Link>
                        <Link to="/programs/ipd" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block pl-8 text-gray-600 hover:text-blue-600 py-1">
                            -- IPD
                        </Link>
                        {/* <div className="block pl-4 py-1 flex items-center justify-between text-gray-400">
                            Our Innovation
                            <span className="text-[10px] bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full font-bold ml-2">Soon</span>
                        </div> */}
                    </div>
                    <Link to="/blog" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block text-gray-800 hover:text-blue-600 py-2">
                        Blog
                    </Link>
                    <Link to="/gallery" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block text-gray-800 hover:text-blue-600 py-2">
                        Gallery
                    </Link>
                    <Link to="/get-involved" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block text-gray-800 hover:text-blue-600 py-2">
                        Get Involved
                    </Link>
                    <Link to="/contact" onClick={() => { setIsOpen(false); window.scrollTo(0, 0); }} className="block text-gray-800 hover:text-blue-600 py-2">
                        Contact
                    </Link>
                    <div className="mt-4 pt-2 border-t border-gray-200 relative">
                        <button
                            onClick={() => setLoginDropdownOpen(!loginDropdownOpen)}
                            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2.5 px-4 rounded-md transition-all duration-200 flex items-center justify-between shadow-md"
                        >
                            Login
                            <svg
                                className={`w-4 h-4 transition-transform duration-200 ${loginDropdownOpen ? 'rotate-180' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        {loginDropdownOpen && (
                            <div className="absolute bottom-full left-0 w-full mb-2 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden animate-in fade-in slide-in-from-bottom-2 duration-200 z-10">
                                <Link
                                    to="/auth/login"
                                    onClick={() => { setIsOpen(false); setLoginDropdownOpen(false); }}
                                    className="flex items-center justify-between px-4 py-3 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-all duration-150 border-b border-gray-100 group"
                                >
                                    <span className="font-medium">Lab Incharge</span>
                                    <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </Link>
                                <Link
                                    to="/auth/login"
                                    onClick={() => { setIsOpen(false); setLoginDropdownOpen(false); }}
                                    className="flex items-center justify-between px-4 py-3 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-all duration-150 border-b border-gray-100 group"
                                >
                                    <span className="font-medium">Admin</span>
                                    <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </Link>
                                <Link
                                    to="/auth/login"
                                    onClick={() => { setIsOpen(false); setLoginDropdownOpen(false); }}
                                    className="flex items-center justify-between px-4 py-3 text-gray-800 hover:bg-gray-100 hover:text-blue-600 transition-all duration-150 group"
                                >
                                    <span className="font-medium">Student</span>
                                    <svg className="w-4 h-4 opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 transition-all duration-150" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </Link>
                            </div>
                        )}
                    </div>
                </div >
            </div >
        </>
    );
};

export default Navbar;